import {useEffect, useState} from 'react'
import {canViewAllLots} from "../../../../../store/centers/reducers";
import { getPromotions } from '../../displays/DisplayPriceBase'

export const productLogic = (props, baseLogicFunction) => {
    const {product, getMin, getStep, getLimit, getType, getTypeProductForStyles, canDisplayDiscontinued, validateOutletPromotions, isCosentinoGlobal, isCosentinoBrazil, canBuyBrand} = baseLogicFunction(props)

    const [qtyToAdd, setQtyToAdd] = useState(1)
    const [step, setStep] = useState(1)
    const [promotions, setPromotions] = useState([])

    useEffect(() => {
        let qtyAdd = 1

        setStep(getStep())

        if (getLimit() === 0) qtyAdd = 0
        else if (getMin()) qtyAdd = getMin()
        else if (product && (product.typeId === '01' || product.typeId === 'NEWS')) qtyAdd = 1
        else if (product.minQty[props.shippingMethod]) qtyAdd = product.minQty[props.shippingMethod]
        setQtyToAdd(qtyAdd)

        generatePromotionTags()
    }, [product, props.lastFetchedDiscountsCenter])

    useEffect(() => {
        let qty = qtyToAdd
        if (getLimit() && getValueWithMax() < qtyToAdd) qty = getValueWithMax()
        if (getMin()) qty = Math.max(getMin(), qty)
        setQtyToAdd(qty)
    }, [qtyToAdd])

    const getExtras = () => {
        let extras = baseLogicFunction(props).getExtras()
        if (isCosentinoGlobal || isCosentinoBrazil) {
            if (!extras) extras = {}
            extras.isCosentinoGlobal = isCosentinoGlobal
            extras.isCosentinoBrazil = isCosentinoBrazil
        }
        return extras
    }

    const addToCart = (extras=null) => {
        extras = extras ? extras : getExtras()
        if (props.needsSegmentation) {
            props.addCartLine(
                product.productId,
                qtyToAdd,
                extras,
                null,
                product.finish === 'AND' && ['DEKTON', 'DKTN'].includes(product.brand),
                product.centerId
            )
        } else {
            props.addCartLineWithouthSeg(product.productId, qtyToAdd, extras)
        }
    }

    const getValueWithMax = () => {
        return qtyToAdd <= getLimit() ? qtyToAdd : getLimit()
    }

    const getValueToAdd = () => {
        let value = getLimit() ? getValueWithMax() : qtyToAdd;
        value = value > 0 ? value : 1;
        return Math.max(getMin(), value)
    }

    const generatePromotionTags = () => {
        const promotionsUpdated = getPromotions(props.productDiscounts, product.outletQuality)
        setPromotions(promotionsUpdated)
    }

    const state = {
        qtyToAdd, setQtyToAdd,
        step, setStep,
        promotions, setPromotions
    }

    const showLots = () => {
        if (product.brand === 'ECLOS') {
            return false
        }

        return getStock() > 0 && product.type === 'SLAB' && (
            (product.brand !== 'SILESTONE' && product.brand !== 'DEKTON')
            // || ((props.impersonatedBy || props.isAdmin) && props.isUsaOrCanada)
            || ((props.impersonatedBy || props.isAdmin || props.canOffer) && props.canViewAllLots)
            || props.isUsaOrCanada || props.isPeruCenter
        )
    }

    const getStock = () => {
        const { canViewThresholdMax } = props
        let result

        if (product.fromMall) {
            result = product.realStock
        } else if (!!props.outlet) {
            result = product.stock_outlet
        } else {
            result = product.stock
        }
        return result
    }

    const goToProductCard = (_product) => {
        _product.extra = getExtras()
        if (props.indexOfList !== undefined) props.clickDetail(_product, props.list, props.indexOfList)
    }

    return {...props,
        state,
        addToCart,
        goToProductCard,
        getExtras,
        getStep,
        getMin,
        getLimit,
        getType,
        product,
        canDisplayDiscontinued,
        getTypeProductForStyles,
        getValueToAdd,
        getStock,
        showLots,
        canBuyBrand
    }
}
